export const ETHIOPIAN_CITIES = [
  'Addis Ababa', 'Dire Dawa', 'Gondar', "Mek'ele", 'Adama / Nazret',
  'Bahir Dar', 'Dessie', 'Hawassa', 'Jimma', 'Bishoftu',
  'Harar', 'Sodo', 'Shashamene', 'Arba Minch', 'Adigrat', 'Debre Birhan',
  'Nekemte', 'Debre Markos', 'Axum', 'Jijiga', 'Woldia', 'Humera',
];

export const CITY_TRANSLATIONS = {
  en: {
    'Addis Ababa': 'Addis Ababa', 'Dire Dawa': 'Dire Dawa', 'Gondar': 'Gondar',
    "Mek'ele": "Mek'ele", 'Adama / Nazret': 'Adama / Nazret', 'Bahir Dar': 'Bahir Dar',
    'Dessie': 'Dessie', 'Hawassa': 'Hawassa', 'Jimma': 'Jimma', 'Bishoftu': 'Bishoftu',
    'Harar': 'Harar', 'Sodo': 'Sodo', 'Shashamene': 'Shashamene',
    'Arba Minch': 'Arba Minch', 'Adigrat': 'Adigrat', 'Debre Birhan': 'Debre Birhan',
    'Nekemte': 'Nekemte', 'Debre Markos': 'Debre Markos', 'Axum': 'Axum',
    'Jijiga': 'Jijiga', 'Woldia': 'Woldia', 'Humera': 'Humera',
  },
  am: {
    'Addis Ababa': 'አዲስ አበባ', 'Dire Dawa': 'ድሬ ዳዋ', 'Gondar': 'ጎንደር',
    "Mek'ele": 'መቀሌ', 'Adama / Nazret': 'አዳማ / ናዝሬት', 'Bahir Dar': 'ባህር ዳር',
    'Dessie': 'ደሴ', 'Hawassa': 'ሐዋሳ', 'Jimma': 'ጅማ', 'Bishoftu': 'ቢሾፍቱ',
    'Harar': 'ሐረር', 'Sodo': 'ሶዶ', 'Shashamene': 'ሻሸመኔ',
    'Arba Minch': 'አርባ ምንጭ', 'Adigrat': 'አዲግራት', 'Debre Birhan': 'ደብረ ብርሃን',
    'Nekemte': 'ነቀምት', 'Debre Markos': 'ደብረ ማርቆስ', 'Axum': 'አክሱም',
    'Jijiga': 'ጅጅጋ', 'Woldia': 'ወልዲያ', 'Humera': 'ሁመራ',
  },
  or: {
    'Addis Ababa': 'Finfinnee', 'Dire Dawa': 'Dire Dhawaa', 'Gondar': 'Gondar',
    "Mek'ele": "Maqalee", 'Adama / Nazret': 'Adaamaa', 'Bahir Dar': 'Baahir Dar',
    'Dessie': 'Dessie', 'Hawassa': 'Hawwasaa', 'Jimma': 'Jimmaa', 'Bishoftu': 'Bishooftuu',
    'Harar': 'Harar', 'Sodo': 'Sodo', 'Shashamene': 'Shaashamannee',
    'Arba Minch': 'Arba Minch', 'Adigrat': 'Adigrat', 'Debre Birhan': 'Debre Birhan',
    'Nekemte': 'Nagelle', 'Debre Markos': 'Debre Markos', 'Axum': 'Axum',
    'Jijiga': 'Jijigaa', 'Woldia': 'Woldiyaa', 'Humera': 'Humeraa',
  },
};

export const BUSINESS_TYPE_GROUPS = {
  en: [
    { group: 'Startups & Entrepreneurs', items: [
      'Tech startups (apps, software, IT services)', 'E-commerce businesses',
      'Digital service startups', 'Creative startups (design, media, photography)',
    ]},
    { group: 'Retail & Wholesale', items: [
      'Shops and minimarkets', 'Clothing and fashion stores', 'Shoe and accessories shops',
      'Electronics and mobile phone shops', 'Cosmetics and beauty product shops',
      'Bookshops and stationery shops', 'Furniture and home appliance shops',
      'Food and beverage wholesalers', 'Construction material suppliers',
      'Agricultural input suppliers', 'Textile and garment wholesalers',
    ]},
    { group: 'Hospitality & Tourism', items: [
      'Restaurants and cafes', 'Traditional food houses',
      'Event and conference venues', 'Car rental services',
    ]},
    { group: 'Educational Institutions', items: [
      'Private schools (KG–Grade 12)', 'Training centers', 'Language schools',
      'Computer and IT training centers', 'Tutorial and exam preparation centers',
      'Online learning platforms', 'Educational consultancy services',
    ]},
    { group: 'Service Providers', items: [
      'Advertising and marketing agencies', 'Printing and publishing services',
      'Graphic design and branding services', 'Accounting and auditing firms',
      'Legal and consultancy services', 'Cleaning and maintenance services',
      'Security service providers', 'Beauty salons and barber shops',
      'Transportation and logistics services',
    ]},
    { group: 'Manufacturers', items: [
      'Food and beverage processing enterprises', 'Garment and textile manufacturers',
      'Shoe and leather product manufacturers', 'Plastic product manufacturers',
      'Metal and wood furniture manufacturers', 'Building material manufacturers',
      'Packaging and labeling manufacturers',
    ]},
    { group: 'Other', items: ['Other'] },
  ],
  am: [
    { group: 'ስታርተፖች እና ስራ ፈጣሪዎች', items: [
      'የቴክ ስታርተፕ (አፕ፣ ሶፍትዌር፣ አይቲ)', 'የኢ-ኮሜርስ ንግዶች',
      'የዲጂታል አገልግሎት ስታርተፕ', 'ፈጠራ ስታርተፕ (ዲዛይን፣ ሚዲያ፣ ፎቶ)',
    ]},
    { group: 'ችርቻሮ እና ጅምላ ንግድ', items: [
      'ሱቆች እና ሚኒ ማርኬቶች', 'የልብስ እና ፋሽን ሱቆች', 'የጫማ እና ጌጣጌጥ ሱቆች',
      'የኤሌክትሮኒክስ እና ሞባይል ሱቆች', 'የኮስሜቲክስ እና ውበት ምርቶች ሱቆች',
      'የመጽሐፍ እና ቁሳቁስ ሱቆች', 'የቤት እቃ ሱቆች',
      'የምግብ እና መጠጥ ጅምላ ሻጮች', 'የግንባታ ቁሳቁስ አቅራቢዎች',
      'የግብርና ግብዓት አቅራቢዎች', 'የጨርቃጨርቅ ጅምላ ሻጮች',
    ]},
    { group: 'ሆቴልና ቱሪዝም', items: [
      'ምግብ ቤቶች እና ካፌዎች', 'ባህላዊ ምግብ ቤቶች',
      'የዝግጅት አዳራሾች', 'የመኪና ኪራይ አገልግሎቶች',
    ]},
    { group: 'የትምህርት ተቋማት', items: [
      'የግል ትምህርት ቤቶች (KG–12)', 'የስልጠና ማዕከሎች', 'የቋንቋ ትምህርት ቤቶች',
      'የኮምፒዩተር እና አይቲ ስልጠና', 'የትምህርት ዝግጅት ማዕከሎች',
      'የኦንላይን ትምህርት', 'የትምህርት አማካሪ አገልግሎቶች',
    ]},
    { group: 'አገልግሎት ሰጪዎች', items: [
      'የማስታወቂያ ኤጀንሲዎች', 'የህትመት አገልግሎቶች',
      'የግራፊክ ዲዛይን', 'የሂሳብ ድርጅቶች',
      'የህግ አማካሪ', 'የጽዳት አገልግሎቶች',
      'የጥበቃ አገልግሎቶች', 'የውበት ሳሎኖች',
      'የትራንስፖርት አገልግሎቶች',
    ]},
    { group: 'አምራቾች', items: [
      'የምግብ እና መጠጥ ማምረቻዎች', 'የጨርቃጨርቅ አምራቾች',
      'የጫማ አምራቾች', 'የፕላስቲክ ምርቶች አምራቾች',
      'የብረት እና እንጨት ቤት እቃ አምራቾች', 'የግንባታ ቁሳቁስ አምራቾች',
      'የማሸጊያ አምራቾች',
    ]},
    { group: 'ሌላ', items: ['ሌላ'] },
  ],
  or: [
    { group: 'Dhaabbilee Haaraa fi Hojjettoota', items: [
      'Startup teeknoloojii', 'Daldala e-commerce',
      'Startup tajaajila dijitaalaa', 'Startup uumamaa',
    ]},
    { group: 'Daldala Xiqqaa fi Guddaa', items: [
      'Suuqii fi minimarket', 'Suuqii uffata', 'Suuqii kophee',
      'Suuqii elektirooniksii', 'Suuqii kosmetiksii',
      'Suuqii kitaabaa', 'Suuqii meeshaa mana',
      'Gurgurtaa nyaataa fi dhugaatii', 'Dhiyeessaa meeshaa ijaarsa',
      'Dhiyeessaa qonnaa', 'Gurgurtaa suufii',
    ]},
    { group: 'Keessummaa fi Turizimii', items: [
      'Mana nyaataa fi kaafee', 'Mana nyaataa aadaa',
      'Bakka walgahii', 'Tajaajila kireeffannaa konkolaataa',
    ]},
    { group: 'Dhaabbilee Barnootaa', items: [
      'Mana barumsaa dhuunfaa', 'Giddugala leenjii', 'Mana barumsaa afaanii',
      'Leenjii kompiyuutaraa', 'Giddugala qormaataa',
      'Barnootaa online', 'Tajaajila gorsa barnootaa',
    ]},
    { group: 'Dhiyeessitootaa Tajaajilaa', items: [
      'Ejensii beeksisaa', 'Tajaajila maxxansaa',
      'Dizaayinii graafiiksii', 'Dhaabbata herregaa',
      'Gorsa seeraa', 'Tajaajila qulqullinaa',
      'Tajaajila eegumsa', 'Saloon miidhagina',
      'Tajaajila geejjibaa',
    ]},
    { group: 'Warshaalee', items: [
      'Warshaa nyaataa fi dhugaatii', 'Warshaa suufii',
      'Warshaa kophee', 'Warshaa plaastiksii',
      'Warshaa meeshaa mana', 'Warshaa meeshaa ijaarsa',
      'Warshaa maxxansaa',
    ]},
    { group: 'Kan Biroo', items: ['Kan Biroo'] },
  ],
};

// Flat list for English (used as stored value in DB)
export const BUSINESS_TYPES = BUSINESS_TYPE_GROUPS.en.flatMap(g => g.items);

// ─── Canonical bazaar categories (the ONLY 8 used everywhere) ──────────────
// Single source of truth for the home "Shop by Category" grid, bazaar/market
// filters, seller product form, buyer views and admin dropdowns.
export const PRODUCT_CATEGORIES = [
  'Handmade Crafts',
  'Fashion',
  'Food & Beverage',
  'Beauty & Health',
  'Home & Living',
  'Sports & Outdoors',
  'Books & Media',
  'Services',
];

// Icon + color for each canonical category (used by Home, Bazaar, Market, Buyer)
export const CATEGORY_ICONS = {
  'handmade crafts': { icon: '🎨', color: '#FFF1F2' },
  'fashion': { icon: '👗', color: '#FEF2F2' },
  'food & beverage': { icon: '🍽️', color: '#FFF7ED' },
  'beauty & health': { icon: '💄', color: '#FDF2F8' },
  'home & living': { icon: '🏠', color: '#FEFCE8' },
  'sports & outdoors': { icon: '⚽', color: '#F0FDF4' },
  'books & media': { icon: '📚', color: '#F5F3FF' },
  'services': { icon: '🔧', color: '#ECFEFF' },
};
const DEFAULT_CATEGORY_ICON = { icon: '📦', color: '#F3F4F6' };

export function categoryIconInfo(name = '') {
  const key = (name || '').trim().toLowerCase();
  return CATEGORY_ICONS[key] || DEFAULT_CATEGORY_ICON;
}

// Maps legacy/alt category names → canonical 8, so a 9th card never appears.
const CATEGORY_NORMALIZE = {
  'food & beverages': 'Food & Beverage',
  'clothing & fashion': 'Fashion',
  'furniture & home': 'Home & Living',
  'beauty & personal care': 'Beauty & Health',
  'health & wellness': 'Beauty & Health',
  'books & stationery': 'Books & Media',
  'sports & fitness': 'Sports & Outdoors',
  'toys & kids': 'Home & Living',
  'agriculture & farm': 'Food & Beverage',
  'construction & hardware': 'Home & Living',
  'automotive': 'Services',
  'clothing': 'Fashion',
  'food': 'Food & Beverage',
  'health': 'Beauty & Health',
  'handmade crafts': 'Handmade Crafts',
  'handicrafts': 'Handmade Crafts',
  'crafts': 'Handmade Crafts',
  'handcraft': 'Handmade Crafts',
  'art & crafts': 'Handmade Crafts',
  'craft': 'Handmade Crafts',
  'home': 'Home & Living',
  'furniture': 'Home & Living',
  'toys': 'Home & Living',
  'kids': 'Home & Living',
  'agriculture': 'Food & Beverage',
  'construction': 'Home & Living',
  'books': 'Books & Media',
  'sports': 'Sports & Outdoors',
  'beauty': 'Beauty & Health',
  'other': 'Services',
};

export function normalizeCategory(name = '') {
  if (!name) return '';
  const trimmed = String(name).trim();
  const key = trimmed.toLowerCase();
  if (PRODUCT_CATEGORIES.includes(trimmed)) return trimmed;
  return CATEGORY_NORMALIZE[key] || trimmed;
}

// Canonical English filter key → i18n key holding its display name. Keeps the
// stored/matched value English while what the user reads follows their language.
const CATEGORY_LABEL_KEYS = {
  'handmade crafts': 'catHandmadeCrafts',
  'fashion': 'catFashion',
  'food & beverage': 'catFoodBeverage',
  'beauty & health': 'catBeautyHealth',
  'home & living': 'catHomeLiving',
  'sports & outdoors': 'catSportsOutdoors',
  'books & media': 'catBooksMedia',
  'services': 'catServices',
};

// Renders any stored/legacy category name in the active language. Unknown names
// are passed through untouched so admin-authored text is never lost.
export function categoryDisplayName(t, name) {
  if (!t || !name) return name || '';
  const key = CATEGORY_LABEL_KEYS[String(name).trim().toLowerCase()];
  return (key && t[key]) || name;
}

// Category name → icon image (public/images), matched by name
const CATEGORY_IMAGES = {
  'agriculture': '/images/bazaar-agriculture.jpg',
  'agriculture and farms': '/images/bazaar-agriculture.jpg',
  'farming': '/images/bazaar-agriculture.jpg',
  'arts': '/images/bazaar-arts.jpg',
  'arts & craft': '/images/bazaar-arts.jpg',
  'arts and craft': '/images/bazaar-arts.jpg',
  'handmade crafts': '/images/bazaar-arts.jpg',
  'art & crafts': '/images/bazaar-arts.jpg',
  'crafts': '/images/bazaar-arts.jpg',
  'craft': '/images/bazaar-arts.jpg',
  'beauty': '/images/bazaar-beauty.jpg',
  'beauty & health': '/images/bazaar-beauty.jpg',
  'beauty & personal': '/images/bazaar-beauty.jpg',
  'health': '/images/bazaar-beauty.jpg',
  'personal': '/images/bazaar-beauty.jpg',
  'construction': '/images/bazaar-construction.jpg',
  'construction and hardware': '/images/bazaar-construction.jpg',
  'hardware': '/images/bazaar-construction.jpg',
  'fashion': '/images/bazaar-fashion.jpg',
  'fashion and clothing': '/images/bazaar-fashion.jpg',
  'clothing': '/images/bazaar-fashion.jpg',
  'food': '/images/bazaar-food.jpg',
  'food & beverage': '/images/bazaar-food.jpg',
  'food & beverages': '/images/bazaar-food.jpg',
  'food and beverages': '/images/bazaar-food.jpg',
  'beverage': '/images/bazaar-food.jpg',
  'home': '/images/bazaar-furniture.jpg',
  'home & living': '/images/bazaar-furniture.jpg',
  'furniture': '/images/bazaar-furniture.jpg',
  'furniture and home': '/images/bazaar-furniture.jpg',
  'living': '/images/bazaar-furniture.jpg',
  'toys': '/images/bazaar-toys.jpg',
  'toys & kids': '/images/bazaar-toys.jpg',
  'toys and kids': '/images/bazaar-toys.jpg',
  'kids': '/images/bazaar-toys.jpg',
  'children': '/images/bazaar-toys.jpg',
  // The canonical 8 have no exact entries above, so these fall through the
  // fuzzy match and resolved to null. Map them to files that actually exist.
  'sports & outdoors': '/images/bazaar-toys.jpg',
  'sports': '/images/bazaar-toys.jpg',
  'outdoors': '/images/bazaar-toys.jpg',
  'books & media': '/images/bazaar-arts.jpg',
  'books': '/images/bazaar-arts.jpg',
  'media': '/images/bazaar-arts.jpg',
  'services': '/images/bazaar-construction.jpg',
  'service': '/images/bazaar-construction.jpg',
};

export function categoryImage(name = '') {
  if (!name) return null;
  const key = name.trim().toLowerCase();
  if (CATEGORY_IMAGES[key]) return CATEGORY_IMAGES[key];
  const match = Object.keys(CATEGORY_IMAGES).find(k => key.includes(k));
  return match ? CATEGORY_IMAGES[match] : null;
}

// ─── Subcategories (seller classify products; market filters by them) ─────
// Each canonical category gets its own list. Sellers pick one when listing.
export const SUBCATEGORIES = {
  'Handmade Crafts': ['Pottery & Ceramics', 'Weaving & Textiles', 'Jewelry & Accessories', 'Leather Goods', 'Woodwork', 'Home Décor'],
  'Fashion': ['Women\'s Clothing', 'Men\'s Clothing', 'Children\'s Clothing', 'Shoes & Bags', 'Traditional Clothing', 'Accessories'],
  'Food & Beverage': ['Coffee & Tea', 'Spices & Grains', 'Honey & Sweets', 'Traditional Food', 'Cold Drinks', 'Kitchen Staples'],
  'Beauty & Health': ['Skincare', 'Haircare', 'Perfume & Fragrance', 'Cosmetics', 'Wellness & Supplements', 'Natural Remedies'],
  'Home & Living': ['Furniture', 'Home Décor', 'Kitchen & Dining', 'Bedding & Linens', 'Lighting', 'Storage'],
  'Sports & Outdoors': ['Sports Equipment', 'Fitness & Exercise', 'Outdoor & Camping', 'Team Sports', 'Cycling', 'Athletic Wear'],
  'Books & Media': ['Books & Literature', 'Stationery & Journals', 'Music & Film', 'Art & Collectibles', 'Magazines'],
  'Services': ['Photography', 'Design & Printing', 'Repair & Maintenance', 'Cleaning', 'Personal Care', 'Classes & Training'],
};

export function subcategoriesFor(category = '') {
  return SUBCATEGORIES[String(category || '').trim()] || [];
}

// Canonical English subcategory name → i18n key holding its display name.
// Subcategory names are matched/stored in English; what the user reads
// follows the active language.
const SUBCATEGORY_LABEL_KEYS = {
  'pottery & ceramics': 'subPotteryCeramics',
  'weaving & textiles': 'subWeavingTextiles',
  'jewelry & accessories': 'subJewelryAccessories',
  'leather goods': 'subLeatherGoods',
  'woodwork': 'subWoodwork',
  'home décor': 'subHomeDecor',
  "women's clothing": 'subWomensClothing',
  "men's clothing": 'subMensClothing',
  "children's clothing": 'subChildrensClothing',
  'shoes & bags': 'subShoesBags',
  'traditional clothing': 'subTraditionalClothing',
  'accessories': 'subAccessories',
  'coffee & tea': 'subCoffeeTea',
  'spices & grains': 'subSpicesGrains',
  'honey & sweets': 'subHoneySweets',
  'traditional food': 'subTraditionalFood',
  'cold drinks': 'subColdDrinks',
  'kitchen staples': 'subKitchenStaples',
  'skincare': 'subSkincare',
  'haircare': 'subHaircare',
  'perfume & fragrance': 'subPerfumeFragrance',
  'cosmetics': 'subCosmetics',
  'wellness & supplements': 'subWellnessSupplements',
  'natural remedies': 'subNaturalRemedies',
  'furniture': 'subFurniture',
  'kitchen & dining': 'subKitchenDining',
  'bedding & linens': 'subBeddingLinens',
  'lighting': 'subLighting',
  'storage': 'subStorage',
  'sports equipment': 'subSportsEquipment',
  'fitness & exercise': 'subFitnessExercise',
  'outdoor & camping': 'subOutdoorCamping',
  'team sports': 'subTeamSports',
  'cycling': 'subCycling',
  'athletic wear': 'subAthleticWear',
  'books & literature': 'subBooksLiterature',
  'stationery & journals': 'subStationeryJournals',
  'music & film': 'subMusicFilm',
  'art & collectibles': 'subArtCollectibles',
  'magazines': 'subMagazines',
  'photography': 'subPhotography',
  'design & printing': 'subDesignPrinting',
  'repair & maintenance': 'subRepairMaintenance',
  'cleaning': 'subCleaning',
  'personal care': 'subPersonalCare',
  'classes & training': 'subClassesTraining',
};

// Renders a stored subcategory name in the active language. Unknown names are
// passed through untouched so admin-authored text is never lost.
export function subcategoryDisplayName(t, name) {
  if (!t || !name) return name || '';
  const key = SUBCATEGORY_LABEL_KEYS[String(name).trim().toLowerCase()];
  return (key && t[key]) || name;
}

// ─── Color palette (seller picks circles; product cards show the dots) ────
export const COLOR_PALETTE = [
  { name: 'Red', hex: '#EF4444' },
  { name: 'Blue', hex: '#3B82F6' },
  { name: 'Green', hex: '#22C55E' },
  { name: 'Yellow', hex: '#EAB308' },
  { name: 'Orange', hex: '#F97316' },
  { name: 'Pink', hex: '#EC4899' },
  { name: 'Purple', hex: '#8B5CF6' },
  { name: 'Teal', hex: '#14B8A6' },
  { name: 'Black', hex: '#111827' },
  { name: 'Gray', hex: '#9CA3AF' },
  { name: 'White', hex: '#FFFFFF' },
  { name: 'Brown', hex: '#92400E' },
  { name: 'Navy', hex: '#1E3A8A' },
  { name: 'Maroon', hex: '#7C2D12' },
  { name: 'Beige', hex: '#EDE0C8' },
  { name: 'Gold', hex: '#D4AF37' },
];

const COLOR_MAP = Object.fromEntries(COLOR_PALETTE.map(c => [c.name.toLowerCase(), c.hex]));

export function colorHex(name = '') {
  if (!name) return null;
  return COLOR_MAP[String(name).trim().toLowerCase()] || null;
}

// Parses the stored colors column ('Red, Blue' | 'Available in all colors') into dots.
// Returns [{ name?, hex? }] or [{ all: true }] for the "every color" sentinel.
export function parseColors(value) {
  if (!value) return [];
  if (String(value).toLowerCase() === 'available in all colors') return [{ all: true }];
  return String(value)
    .split(',')
    .map(s => s.trim())
    .filter(Boolean)
    .map(name => ({ name, hex: colorHex(name) }));
}
